export const TabDragType = 'NOVA_TAB';
export let TabBarVariant = /*#__PURE__*/function (TabBarVariant) {
  TabBarVariant["Standard"] = "standard";
  TabBarVariant["PrimaryLight"] = "primary-light";
  return TabBarVariant;
}({});

// DND allows re-order of

/**
 *  @deprecated
 * */

/**
 *  @deprecated
 * */

/**
 * Don't use Tab outside of Tabbar, please use the Tabbar instead.
 */
//# sourceMappingURL=types.js.map